import React from "react";
import { dateToToday } from "../../../utils/helper.jsx";
const ReceivedMessageContent = ({ message }) => {
  return (
    <>
      <div className="widget-chat-item">
        <div className="widget-chat-media">
          <img src="/assets/img/ai_face.png" alt="" />
        </div>
        <div className="widget-chat-content">
          <div className="widget-chat-name">
            GINA - {dateToToday(message?.created_at)}
          </div>
          <div className="widget-chat-message last">{message?.content}</div>
        </div>
      </div>
    </>
  );
};

export default ReceivedMessageContent;
